import { render, staticRenderFns } from "./PublishLogistics.vue?vue&type=template&id=387afbe5&scoped=true"
import script from "./PublishLogistics.vue?vue&type=script&lang=js"
export * from "./PublishLogistics.vue?vue&type=script&lang=js"
import style0 from "./PublishLogistics.vue?vue&type=style&index=0&id=387afbe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387afbe5",
  null
  
)

export default component.exports